import { useSelector } from "react-redux";
import pageContext from "core/pageContext";
import { ClaimReportingUrlsDto } from "types/generated";

export const useGetClaimReportingUrls: () => ClaimReportingUrlsDto = () => {
    return useSelector(pageContext.getClaimReportingUrls);
};
